import React from 'react';
import deviceTypes from '../../../settings/venue/device/deviceTypes';

const NodeTypeField = props => {
    const displayName = deviceTypes.nodeTypes.find(nt => nt.key === parseInt(props.nodeType))?.display;
    return <span>{displayName || 'Unknown'}</span>
}

export default NodeTypeField;